module.exports = __webpack_public_path__ + "static/media/product-6.4d78ee1d.png";